export default {
  DEFAULT: 'DEFAULT',
  NO_USER: 'NO_USER',
  INDEX: 'INDEX',
  INNER: 'INNER',
  SCHOOL: 'SCHOOL',
  NULL: 'NULL',
  SL: 'SL',
  TEACHER: 'TEACHER',
  BY_ROLE: 'BY_ROLE',
  TEXT_BLOCK: 'TEXT_BLOCK',
  BACK: 'BACK'
};
